'use client'

// Community CTA (2026-07-24, waitlist framing 2026-08-02). Copy mirrors the /joinus LP on
// the .org microsite — keep the two in sync when the offer changes (ea-lp repo,
// /joinus page). Everyone — logged in or not — goes to the LP; that page IS the join path
// (Veronika 2026-07-25). Clicks are PostHog-tracked and UTM-tagged per placement; event
// name and UTM campaign kept from the founding-50 era for dashboard continuity. No em dash and
// no arrow in the copy, site-wide (style guide; Connor 2026-10-14).
import React from 'react'
import { trackEvent } from '@/lib/analytics/posthog'

const LP_JOIN_URL = 'https://www.electrification-academy.org/joinus'

export const CommunityCTA: React.FC<{ placement: string }> = ({ placement }) => {
  const href = `${LP_JOIN_URL}?utm_source=platform&utm_medium=cta&utm_campaign=founding-50&utm_content=${encodeURIComponent(placement)}`

  return (
    <aside className="join-cta" data-placement={placement}>
      <div className="join-cta-k">EA Community</div>
      <h3>Ask a question, or contribute to our community.</h3>
      <p>
        A community of battery and electrification professionals, ready to exchange and
        answer each other&rsquo;s questions. Free while we&rsquo;re early.
      </p>
      <a
        className="join-cta-btn"
        href={href}
        onClick={() => trackEvent('founding50_cta_click', { placement })}
      >
        Join the community waitlist
      </a>
    </aside>
  )
}
